import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "../components/Header";
import Footer from "../components/Footer";
import api from "../utils/api";

export default function CustomPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const contentRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    api.get(`/pages/${slug}`)
      .then((res) => setPage(res.data))
      .catch((err) => setError(err.response?.status === 404 ? "Seite nicht gefunden" : "Fehler beim Laden"))
      .finally(() => setLoading(false));
  }, [slug]);

  // Execute <script> tags injected via dangerouslySetInnerHTML
  useEffect(() => {
    if (!contentRef.current || !page) return;
    const scripts = contentRef.current.querySelectorAll("script");
    scripts.forEach((old) => {
      const s = document.createElement("script");
      Array.from(old.attributes).forEach((a) => s.setAttribute(a.name, a.value));
      if (old.textContent) s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }, [page]);

  return (
    <div className="min-h-screen bg-[#050505]">
      <Header />
    <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-8 pb-20">
        {loading && (
          <div className="space-y-4 animate-pulse">
            <div className="h-8 bg-zinc-800 rounded w-2/3" />
            <div className="h-4 bg-zinc-900 rounded w-full" />
            <div className="h-4 bg-zinc-900 rounded w-5/6" />
          </div>
        )}
        {error && (
          <div className="text-center py-20">
            <p className="text-zinc-500 text-xl">{error}</p>
          </div>
        )}
        {page && (
          <article>
            <Helmet>
              <title>{`${page.title || ''} | HUWND`}</title>
              {page.meta_description ? <meta name="description" content={page.meta_description} /> : null}
              <link rel="canonical" href={`https://handsupwillneverdie.de/page/${page.slug}`} />
              <meta property="og:title" content={`${page.title || ''} | HUWND`} />
              <meta property="og:url" content={`https://handsupwillneverdie.de/page/${page.slug}`} />
            </Helmet>
            <h1 className="text-4xl sm:text-5xl font-black text-white font-heading mb-8 leading-tight">{page.title}</h1>
            <div
              ref={contentRef}
              className="prose prose-invert prose-zinc max-w-none text-zinc-300 leading-relaxed [&>*:first-child]:mt-0 [&_#myShop]:mt-0 [&_iframe]:block [&_iframe]:w-full"
              dangerouslySetInnerHTML={{ __html: page.content }}
            />
          </article>
        )}
      </div>
      <Footer />
    </div>
  );
}
